import React from 'react';
import { Globe } from 'lucide-react';

const regions = [
  { id: 'united-states', name: 'United States' },
  { id: 'caribbean', name: 'Caribbean' },
  { id: 'global', name: 'Global' }
];

const RegionSelector = ({ selectedRegion, onRegionChange, regionName }) => {
  return (
    <section 
      className="sticky top-0 z-50 bg-black border-b border-white/10"
      data-testid="region-selector"
      id="services"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Region Label */}
          <div className="flex items-center gap-4">
            <Globe className="w-4 h-4 text-[#C9A227]" />
            <span className="text-white/40 text-xs tracking-[0.2em] uppercase">
              Region
            </span>
            <span className="text-white/20 mx-2">|</span>
            <span className="text-[#C9A227] text-sm font-medium">
              {regionName}
            </span>
          </div>

          {/* Region Switch */}
          <div className="flex items-center gap-1 bg-white/5 p-1">
            {regions.map((region) => (
              <button
                key={region.id}
                onClick={() => onRegionChange(region.id)}
                className={`px-5 py-2 text-xs tracking-wider uppercase transition-all duration-300 ${
                  selectedRegion === region.id 
                    ? 'bg-[#C9A227] text-black font-medium' 
                    : 'text-white/50 hover:text-white hover:bg-white/10'
                }`}
                data-testid={`region-btn-${region.id}`}
              >
                {region.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionSelector;
